/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
Comparison block for land/fire
*/
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs, getAllowedStatements } from '../block_compatibility_checks';

Blockly.Blocks['analyse_fires_to_land_comparison'] = {
    init: function () {
        this.appendDummyInput()
            .appendField('Compare to landcover: ')
            .appendField(new Blockly.FieldDropdown([
                ['Copernicus\u00A0Global\u00A0(2015)', 'copernicus_cover_2015'],
                ['Copernicus\u00A0Global\u00A0(2016)', 'copernicus_cover_2016'],
                ['Copernicus\u00A0Global\u00A0(2017)', 'copernicus_cover_2017'],
                ['Copernicus\u00A0Global\u00A0(2018)', 'copernicus_cover_2018'],
                ['Copernicus\u00A0Global\u00A0(2019)', 'copernicus_cover_2019']
                ]), "dropdownLand");



        this.appendDummyInput('AgricultureLabel').appendField('Agriculture:')
        this.appendDummyInput('Agriculture')
            .appendField(" Agriculture")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_40')

        this.appendDummyInput('BareLandLabel').appendField('Bare Land:')
        this.appendDummyInput('BareLand')
            .appendField(" Bare Land")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_60')
        this.appendDummyInput('ForestLabel').appendField('Closed Forest:')
        this.appendDummyInput('Forest1')
            .appendField(" Evergreen Needle")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_111')
            .appendField(" Evergreen Leaf")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_112')
            .appendField(" Deciduous Needle")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_113')
        this.appendDummyInput('Forest2')
            .appendField(" Deciduous Leaf")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_114')
            .appendField(" Mixed Forest")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_115')
            .appendField(" Other Forest")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_116')

        this.appendDummyInput('ForestLabel2').appendField('Open Forest:')
        this.appendDummyInput('Forest3')
            .appendField(" Evergreen Needle")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_121')
            .appendField(" Evergreen Leaf")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_122')
            .appendField(" Deciduous Needle")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_123')
        this.appendDummyInput('Forest4')
            .appendField(" Deciduous Leaf")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_124')
            .appendField(" Mixed Forest")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_125')
            .appendField(" Other Forest")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_126')

        this.appendDummyInput('VegetationLabel').appendField('Vegetation:')
        this.appendDummyInput('Vegetation')
            .appendField(" Shrubs")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_20')
            .appendField(" Vegetation")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_30')

        this.appendDummyInput('UrbanLabel').appendField('Urban:')
        this.appendDummyInput('Urban')
            .appendField(" Urban")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_50')

        this.appendDummyInput('WaterAndIceLabel').appendField('Water & Ice:')
        this.appendDummyInput('WaterAndIce')
            .appendField(" Ice")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_70')
            .appendField(" Water")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_80')
            .appendField(" Sea")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_200')

        this.appendDummyInput('WetlandsLabel').appendField('Wetlands:')
        this.appendDummyInput('Wetlands')
            .appendField(" Wetlands")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_90')
            .appendField(" Moss")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_100')

        this.appendDummyInput('UnclassifiedLabel').appendField('Unclassified:')
        this.appendDummyInput('Unclassified')
            .appendField(" Unknown")
            .appendField(new Blockly.FieldCheckbox('FALSE'), 'check_0')

        this.setTooltip(this.tootltipset());
        this.setHelpUrl("");
        let previousLandDataset = 'copernicus_cover_2015';
        this.prevpar = this.getParent() 

        this.setOnChange(function () {
            if (this.getFieldValue('dropdownLand') !== previousLandDataset || (this.prevpar !== this.getParent())) {
                this.updateShape_(previousLandDataset);
                previousLandDataset = this.getFieldValue('dropdownLand');
                this.prevpar = this.getParent()
            }
        });

        this.setPreviousStatement(true, 'comparison');
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('comparison'))
        this.setNextStatement(true, getAllowedOutputs('comparison'));
        this.setInputsInline(false);
        this.setStyle('comparison');
    },

    tootltipset: function () {
        var land = this.getFieldValue('dropdownLand');
        var basic = Blockly.Msg.COMPARISON_BLOCK_TOOLTIP;
        var TOOLTIPS = {
            'copernicus_cover_2015': Blockly.Msg.COPERNICUS_COVER_2015,
            'copernicus_cover_2016': Blockly.Msg.COPERNICUS_COVER_2016,
            'copernicus_cover_2017': Blockly.Msg.COPERNICUS_COVER_2017,
            'copernicus_cover_2018': Blockly.Msg.COPERNICUS_COVER_2018,
            'copernicus_cover_2019': Blockly.Msg.COPERNICUS_COVER_2019,
        };
        basic += TOOLTIPS[land];
        return basic;
    },

    updateShape_: function () {
        this.setTooltip(this.tootltipset());
    },

};